import { PreviewComponent } from '@/services/utils/basePreview'
import { metadataLabelValues } from '@/shared/helpers/metadataLabelValues'
import { ILocalDelivery } from '@/modules/preference/local-delivery/types/localDeliveryTypes'

/**
 * dynamic component generator method
 * @param localDelivery is ILocalDelivery interface type which
 * @return An Array of IPreviewComponent ILocalDelivery type
 */
export function localDeliveryPreviewComponents(
  localDelivery: ILocalDelivery
): PreviewComponent<ILocalDelivery>[] {
  return [
    PreviewComponent.labelValue<ILocalDelivery>(
      'city',
      'city',
      localDelivery?.city?.name
    ).setTitle('localDeliveryDetails'),
    PreviewComponent.labelValue<ILocalDelivery>(
      'DeliveryPrice',
      'price',
      localDelivery.price
    ),
    PreviewComponent.labelValue<ILocalDelivery>(
      'DeliveryCost',
      'cost',
      localDelivery.cost
    ),
    PreviewComponent.labelValue<ILocalDelivery>(
      'isDefault',
      'isDefault',
      localDelivery.isDefault ? 'Yes' : 'No'
    ).setClass(`${localDelivery?.isDefault ? 'success' : 'error'}--text`),
    ...metadataLabelValues(localDelivery)
  ]
}
